
import { Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const DesktopLink = ({ to, children }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <>
            <Button
                component={Link}
                to={to}
                sx={{
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    display: { xs: 'none', sm: 'block' },
                    fontWeight: "600",
                    fontFamily: "Roboto",
                    fontSize: '14px',
                    pt: 1.2,
                    px: 2,
                    color: isActive ? theme.palette.secondary.main : theme.palette.primary.main,
                    '&:hover': {
                        backgroundColor: "unset",
                        color: theme.palette.secondary.main
                    }
                }}>
                {children}
            </Button>
        </>
    );
};

export default DesktopLink;
